"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Fieldset = _interopRequireDefault(require("../Fieldset"));

var _safeMapAndCloneChildren = _interopRequireDefault(require("../utils/safeMapAndCloneChildren"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].element)]),
  className: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  error: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].bool]),
  onChange: _propTypes["default"].func,
  textSize: _propTypes["default"].string,
  value: _propTypes["default"].string
};
var defaultProps = {
  error: false,
  onChange: function onChange() {},
  textSize: 'normal'
};

var RadioGroup = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RadioGroup, _Component);

  function RadioGroup(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleChange = function (value) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: value
      });

      onChange(value);
    };

    _this.state = {
      value: props.value || props.defaultValue
    };
    return _this;
  }

  var _proto = RadioGroup.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var stateValue = this.state.value;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        value = _this$props.value,
        onChange = _this$props.onChange,
        defaultValue = _this$props.defaultValue,
        textSize = _this$props.textSize,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "value", "onChange", "defaultValue", "textSize"]);

    var classes = (0, _classnames["default"])('grv-radiobutton__group', className);
    return /*#__PURE__*/_react["default"].createElement(_Fieldset["default"], _extends({}, otherProps, {
      className: classes,
      textSize: textSize
    }), (0, _safeMapAndCloneChildren["default"])(children, function (child) {
      return {
        checked: (value || stateValue) === child.props.value,
        key: child.props && child.props.value,
        onSelect: _this2.handleChange
      };
    }));
  };

  return RadioGroup;
}(_react.Component);

RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;
var _default = RadioGroup;
exports["default"] = _default;